import CookiesEuBanner from "cookies-eu-banner";

new CookiesEuBanner(function () {
  if(window.whenConsent){
      window.whenConsent();
  }
}, true, true);
